export let getToken = () => {
  let token = localStorage.getItem("29687553806214734460379322763426");
  if (!token) {
    token = "";
  }
  return token;
};

export let setToken = (token) => {
  localStorage.setItem("29687553806214734460379322763426", token);
};

export let redirectIfNotToken = (url) => {
  const token = getToken();
  if (token === "") {
    location.href = url;
  }
};

export let redirectIfToken = (url) => {
  const token = getToken();
  if (token !== "") {
    location.href = url;
  }
};

export let getLanguage = () => {
  let lang = localStorage.getItem("lang");
  if (!lang) {
    lang = "es";
  }
  return lang;
};

export let setLanguage = (lang) => {
  localStorage.setItem("lang", lang);
};
